/**
 * Which tab of the property page a link asks for, as the `tab` search param carries it.
 *
 * Its own module because both the tab container and `urlBuilder` need the same values.
 * `Overview` has no tab of its own on the page, and an unknown value falls back to the
 * first tab.
 */
export enum PropertyTab {
  Overview = 'overview',
  NeedsAttention = 'needs-attention',
  Knowledge = 'knowledge',
  Contracts = 'contracts',
  Cars = 'elevators',
  // Labelled "Service History" on the page since the callbacks sub-tab joined it.
  // The value stays as it is: links already point at it.
  VisitsCompletion = 'maintenance-completion',
  Tickets = 'tickets',
  Spending = 'spending',
  Tasks = 'tasks',
}
